import ListItem, { ListItemProps } from "@material-ui/core/ListItem"
import { wrapLink, LinkProps } from "./Link";



export type ListItemButtonLinkProps = Omit<ListItemProps, "button" | "component"> & LinkProps;
export const ListItemButtonLink = wrapLink<ListItemButtonLinkProps>(ListItem, { button: true});
